import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "fileType-text",
  "use": "fileType-text-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 20 20\" id=\"fileType-text\"><defs><symbol id=\"fileType-text_a\" data-name=\"file-text\" viewBox=\"0 0 20 20\"><path d=\"M15.77 0H0v20h20V4.23zm-3 7.43h-2.39v6.21H9.3V7.43H6.91V6.5h5.85zm3-3.06V.28l4.08 4.08z\" fill=\"#00a0e9\" /></symbol></defs><title>fileType-text</title><g data-name=\"图层 2\"><use width=\"20\" height=\"20\" xlink:href=\"#fileType-text_a\" data-name=\"图层 1\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/fileType-text.svg
// module id = PY3c
// module chunks = 6